<script>
import { required } from "vuelidate/lib/validators";
import { authComputed } from "@/state/helpers";
import Swal from "sweetalert2";

// Additional filed data default value
export default {
  components: {},
  data() {
    return {
      is_btn_loading: false,
      additional_field: {
        field_label: "",
        field_text: "",
        section_label: "",
        section_text: "",
        select_section: "",
        answer_type: "text",
        value: "",
        is_required: true,
        is_registration_card_show: true,
        is_show_on_booking: true,
        is_show_on_additional_question: false,
        form_data: {
          max: 250,
          min: 0,
        },
        form_data_options: [
          {
            option: null,
          },
        ],
        sectionLabelOption: [
          {
            text: "Add New Section",
            value: "ans",
          },
        ],
      },
      isAdditionalOptionShow: false,
      submitted: false,
      isSaveAndAddNew: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.isEditAddField();
  },
  methods: {
    // Method is used to set edited data in form
    isEditAddField() {
      if (this.currentProps.isEdit) {
        this.additional_field = {
          ...this.additional_field,
          select_section: this.currentProps.selectedField.section_label,
          ...this.currentProps.selectedField,
          sectionLabelOption: [
            ...this.additional_field.sectionLabelOption,
            ...this.currentProps.sectionLabelOptions,
          ],
        };
        this.updateAnswerTypeOption();
      } else {
        this.additional_field.sectionLabelOption = [
          ...this.additional_field.sectionLabelOption,
          ...this.currentProps.sectionLabelOptions,
        ];
      }
      this.additional_field.sectionLabelOption = [
        ...new Set(this.additional_field.sectionLabelOption),
      ];
    },
    // Method is used to maintain addition option show
    updateAnswerTypeOption() {
      this.isAdditionalOptionShow = false;
      if (this.additional_field.answer_type == "text") {
        this.isAdditionalOptionShow = true;
      }
    },
    // Method is use for add options in choice and multi select
    AddFormData() {
      this.additional_field.form_data_options.push({ option: null });
    },
    // Method is used to remove some option from option from data
    deleteRow(index) {
      Swal.fire({
        title: "Are you sure you want to delete this element?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.additional_field.form_data_options.splice(index, 1);
        }
      });
    },
    // Method is used to add new field in additional field
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.additional_field.select_section !== "ans") {
        this.additional_field.section_text =
          this.additional_field.select_section;
      }
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let field_label = this.additional_field.field_text
          .toLowerCase()
          .replace(" ", "_");
        let section_label = this.additional_field.section_text
          .toLowerCase()
          .replace(" ", "_");
        this.additional_field = {
          ...this.additional_field,
          field_label,
          section_label,
        };
        if (this.isSaveAndAddNew) {
          this.$emit("saveAndAddNew", this.additional_field);
        } else {
          this.$emit(
            "submitted",
            this.currentProps.isEdit,
            this.additional_field
          );
        }
        this.submitted = false;
        this.is_btn_loading = false;
        this.additional_field = {
          field_label: "",
          field_text: "",
          section_label: "",
          section_text: "",
          select_section: "",
          answer_type: "",
          value: "",
          is_required: false,
          is_registration_card_show: false,
          is_show_on_booking: false,
          is_show_on_additional_question: false,
          form_data: {
            max: 20,
            min: 10,
          },
        };
      }
    },
    // Method is used to add and continue adding new
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is used for canceling
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
  },
  validations: {
    additional_field: {
      field_text: { required },
      section_text: { required },
      select_section: { required },
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{ this.currentProps.isEdit ? "Update Field" : "Add New Field" }}
        </h4>
        <hr />
      </div>

      <div class="col-md-6">
        <b-form-group
          class="mb-3 form-label"
          id="select_section"
          label="Section Label"
          label-for="select_section"
        >
          <span slot="label"
            >Section Label <span class="text-danger">*</span></span
          >
          <b-form-select
            class="form-select"
            id="select_section"
            type="text"
            placeholder="Enter section Ex: Vehicle Info"
            v-model="additional_field.select_section"
            :options="additional_field.sectionLabelOption"
            :class="{
              'is-invalid':
                submitted && $v.additional_field.select_section.$error,
            }"
          >
          </b-form-select>
        </b-form-group>
        <div
          v-if="submitted && $v.additional_field.select_section.$error"
          class="invalid-feedback"
        >
          <span
            class="text-danger"
            v-if="!$v.additional_field.select_section.required"
            >Please select a section.</span
          >
        </div>
      </div>
      <div class="col-md-6" v-if="additional_field.select_section == 'ans'">
        <b-form-group
          class="mb-3 form-label"
          id="section_text"
          label="Section Label"
          label-for="section_text"
        >
          <span slot="label"
            >Section Text <span class="text-danger">*</span></span
          >
          <b-form-input
            class="form-input"
            id="section_text"
            type="text"
            placeholder="Enter section Ex: Vehicle Info"
            autocomplete="off"
            v-model="additional_field.section_text"
            :class="{
              'is-invalid':
                submitted && $v.additional_field.section_text.$error,
            }"
          >
          </b-form-input>
        </b-form-group>
        <div
          v-if="submitted && $v.additional_field.section_text.$error"
          class="invalid-feedback"
        >
          <span
            class="text-danger"
            v-if="!$v.additional_field.section_text.required"
            >Section Text is required.</span
          >
        </div>
      </div>
      <div class="col-md-6">
        <b-form-group
          class="mb-3 form-label"
          id="field_text"
          label="Field Label"
          label-for="field_text"
        >
          <span slot="label"
            >Field Text <span class="text-danger">*</span></span
          >
          <b-form-input
            class="form-input"
            id="field_text"
            type="text"
            placeholder="Enter Field label Ex :License plate"
            autocomplete="off"
            v-model="additional_field.field_text"
            :class="{
              'is-invalid': submitted && $v.additional_field.field_text.$error,
            }"
          >
          </b-form-input>
        </b-form-group>
        <div
          v-if="submitted && $v.additional_field.field_text.$error"
          class="invalid-feedback"
        >
          <span
            class="text-danger"
            v-if="!$v.additional_field.field_text.required"
            >Field Text is required.</span
          >
        </div>
      </div>
    </div>
    <!--Show params -->
    <div class="row">
      <div class="col-md-6">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_required"
            v-model="additional_field.is_required"
          />
          <label class="form-check-label" for="is_required">Required</label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_registration_card_show"
            v-model="additional_field.is_registration_card_show"
          />
          <label class="form-check-label" for="is_registration_card_show"
            >Show On Guest Registration Card</label
          >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_show_on_booking"
            v-model="additional_field.is_show_on_booking"
          />
          <label class="form-check-label" for="is_show_on_booking"
            >Show On Booking</label
          >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_show_on_additional_question"
            v-model="additional_field.is_show_on_additional_question"
          />
          <label class="form-check-label" for="is_show_on_additional_question"
            >Show On Additional Question</label
          >
        </div>
      </div>
      <hr />
      <!-- save button div -->
      <div class="col-md-12">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >

        <b-button
          variant="outline-primary"
          class="float-end ms-2"
          type="submit"
          @click="onSubmit"
          :class="{
            disabled: isSaveAndAddNew !== true && is_btn_loading,
          }"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isSaveAndAddNew !== true && is_btn_loading"
          ></i>
          {{ this.currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<!-- 
  
    <b-button
                v-if="!this.currentProps.isEdit"
                class="float-end ms-2"
                variant="outline-primary"
                type="submit"
                @click="saveAndAddNew"
                :class="{
                  disabled: isSaveAndAddNew === true && is_btn_loading,
                }"
              >
                <i
                  v-if="isSaveAndAddNew === true && is_btn_loading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i
                >Save & Add</b-button
              > 
  if (
          this.additional_field.answer_type == "multi_select" ||
          this.additional_field.answer_type == "choice" ||
          this.additional_field.answer_type == "select"
        ) {
          delete this.additional_field.form_data;
        } else {
          delete this.additional_field.form_data_options;
        } -->
<!-- ||
        this.additional_field.answer_type == "number" ||
        this.additional_field.answer_type == "date" ||
        this.additional_field.answer_type == "textarea" ||
        this.additional_field.answer_type == "multi_select" ||
        this.additional_field.answer_type == "choice" ||
        this.additional_field.answer_type == "select" -->
<!-- date -->
<!-- additional options -->
<!-- <div class="row mt-3" v-if="isAdditionalOptionShow">
            <div class="col-md-12">
              <div role="tablist">
                <b-card no-body class="mb-1 shadow-none">
                  <b-card-header header-tag="header" role="tab">
                    <h5 class="m-0">
                      <a
                        v-b-toggle.addition_question
                        class="text-dark"
                        href="javascript: void(0);"
                        >Additional Option</a
                      >
                    </h5>
                  </b-card-header>
                  <b-collapse
                    id="addition_question"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div
                          class="row mt-3 short_text"
                          v-if="additional_field.answer_type == 'text'"
                        >
                          <div class="col-md-12">
                            <b-form-group
                              class="mb-3"
                              label="Minimum Character"
                              label-for="min_char"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="min_char"
                                type="number"
                                min="1"
                                v-model="additional_field.form_data.min"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              class="mb-3"
                              label="Maximum Character"
                              label-for="max_char"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="max_char"
                                type="number"
                                min="1"
                                v-model="additional_field.form_data.max"
                              ></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div> -->
<!-- <div
                          class="row mt-3 date"
                          v-else-if="additional_field.answer_type == 'date'"
                        >
                          <div class="col-md-12">
                            <b-form-group
                              class="mb-3"
                              label="Minimum Date"
                              label-for="min_date"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="min_date"
                                type="date"
                                v-model="additional_field.form_data.min"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              class="mb-3"
                              label="Maximum Date"
                              label-for="max_date"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="max_date"
                                type="date"
                                v-model="additional_field.form_data.max"
                              ></b-form-input>
                            </b-form-group>
                          </div>
                        </div> -->

<!-- number -->
<!-- <div
                          class="row mt-3 number"
                          v-else-if="additional_field.answer_type == 'number'"
                        >
                          <div class="col-md-12">
                            <b-form-group
                              class="mb-3"
                              label="Minimum Number"
                              label-for="min_num"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="min_num"
                                type="number"
                                value="10"
                                min="1"
                                v-model="additional_field.form_data.min"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              class="mb-3"
                              label="Maximum Number"
                              label-for="max_num"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="max_num"
                                type="number"
                                value="20"
                                min="1"
                                v-model="additional_field.form_data.max"
                              ></b-form-input>
                            </b-form-group>
                          </div>
                        </div> -->

<!-- long text -->
<!-- <div
                          class="row mt-3 long_text"
                          v-else-if="additional_field.answer_type == 'textarea'"
                        >
                          <div class="col-md-12">
                            <b-form-group
                              class="mb-3"
                              label="Minimum Character"
                              label-for="min_char"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="min_char"
                                type="number"
                                min="1"
                                v-model="additional_field.form_data.min"
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              class="mb-3"
                              label="Maximum Character"
                              label-for="max_char"
                              label-cols-sm="3"
                            >
                              <b-form-input
                                id="max_char"
                                type="number"
                                min="1"
                                v-model="additional_field.form_data.max"
                              ></b-form-input>
                            </b-form-group>
                          </div>
                        </div> -->

<!-- options -->
<!-- <div
                          class="row option_parts"
                          id="options_title"
                          v-else-if="
                            additional_field.answer_type == 'choice' ||
                            additional_field.answer_type == 'multi_select' ||
                            additional_field.answer_type == 'select'
                          "
                        >
                          <div class="editable-title text-dark">
                            Answers <span class="text-danger">*</span>
                          </div>
                          <p class="text-secondary">
                            Customer can select one of the following:
                          </p>
                          <div
                            v-for="(
                              field, index
                            ) in additional_field.form_data_options"
                            :key="index"
                            class="row mb-2"
                          >
                            <div class="col-1 mt-2 editable-title text-center">
                              <h5>{{ index + 1 }}</h5>
                            </div>
                            <div class="col-lg-4">
                              <input
                                id="text"
                                v-model="field.option"
                                type="text"
                                placeholder="Option"
                                class="form-control"
                                autocomplete="off"
                              />
                            </div>
                            <div
                              class="col-lg-2 align-self-center"
                              v-if="index !== 0"
                            >
                              <a href="#" @click="deleteRow(index)">
                                <i
                                  class="
                                    fa fa-trash-alt
                                    pb-1
                                    mt-1
                                    text-danger
                                    editable-title
                                  "
                                ></i>
                              </a>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-12">
                              <a
                                id="add_new_option"
                                class="fw-bold option_parts cursor"
                                @click="AddFormData"
                                >+ Add Another</a
                              >
                            </div>
                          </div>
                        </div> -->

<!-- Field input option -->
<!-- <div class="row mt-3">
            <div class="col-md-12">
              <b-form-group
                class="mb-3 form-label"
                id="input-group-1"
                label="Answer Type"
                label-for="answer_type"
              >
                <span slot="label"
                  >Answer Type <span class="text-danger">*</span></span
                >
                <b-form-select
                  class="form-select"
                  id="answer_type"
                  type="text"
                  v-model="additional_field.answer_type"
                  :options="answer_type"
                  @change="updateAnswerTypeOption"
                  :class="{
                    'is-invalid':
                      submitted && $v.additional_field.answer_type.$error,
                  }"
                >
                </b-form-select>
              </b-form-group>
              <div
                v-if="submitted && $v.additional_field.answer_type.$error"
                class="invalid-feedback"
              >
                <span
                  class="text-danger"
                  v-if="!$v.additional_field.answer_type.required"
                  >Please select answer type.</span
                >
              </div>
            </div>
          </div> -->
<!-- form_data_options: [
            {
              option: null,
            },
          ], -->
